// extracted by mini-css-extract-plugin
export default {"primeBoardParent":"PrimeCommunityBoardPage_primeBoardParent__sPhpV"};